import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import useAuth from '@hooks/useAuth'
import { useGetTextSettingsByCodeQuery } from '@services/settings'
import { TextSettingsCodes } from '@models/settings'
import { Routes } from '@enums/Routes'
import { StyledLink } from './styled'

type Props = {
  text: string
  isLogout?: boolean
  route?: Routes
  handleItemClick?: () => void
  isSiteLink?: boolean
  href?: string
}

const LinkItem: FC<Props> = ({
  text,
  isLogout,
  route,
  handleItemClick,
  isSiteLink,
  href,
}) => {
  const { data: siteLink } = useGetTextSettingsByCodeQuery(
    TextSettingsCodes.SITE_LINK
  )

  const navigate = useNavigate()
  const { logout } = useAuth()

  const handleClick = () => {
    handleItemClick?.()

    if (href) {
      window.open(href, '_blank')
      return
    }

    if (isSiteLink) {
      window.open(siteLink?.text, '_blank')
      return
    }

    if (isLogout) {
      logout()
      return
    }

    if (route) {
      navigate(route)
    }
  }

  return (
    <StyledLink key={text} onClick={handleClick}>
      {text}
    </StyledLink>
  )
}

export type { Props as LinkItemProps }
export default LinkItem
